import { Injectable } from '@nestjs/common';
import { EntityRepository, Repository } from 'typeorm';
import { Supplier } from '../supplier.entity';

@Injectable()
@EntityRepository(Supplier)
export class SupplierRepo extends Repository<Supplier> {

    constructor() {
        super();
    }

    async getAgentCode(): Promise<any> {
        const query = this.createQueryBuilder('')
            .select(` supplier_id, code as supplierCode, name `)
            .where(` supplier_category = "Agent"`);
        query.groupBy(` code`)
        query.orderBy(` created_at`, 'DESC')
        return await query.getRawOne();
    }

    async getBrokerCode(): Promise<any> {
        const query = this.createQueryBuilder('')
            .select(` supplier_id, code as supplierCode, name`)
            .where(` supplier_category = "Dealer"`);
        query.groupBy(`code`)
        query.orderBy(` created_at`, 'DESC')
        return await query.getRawOne();
    }
    async getFarmerCode(): Promise<any> {
        const query = this.createQueryBuilder('')
            .select(` supplier_id, code as supplierCode, name`)
            .where(` supplier_category = "Farmer"`);
        query.groupBy(`code`)
        query.orderBy(` created_at`, 'DESC')
        return await query.getRawOne();
    }
}